export enum EnumQuoteType {
    STANDARD = 'STANDARD',
    CMC = 'CMC'
}
